import logger from '@service/logger';

export class Storable {
  /**
   * The key used to store the data in localStorage or sessionStorage.
   * @type {string}
   */
  storageKey = 'storageKey';

  setStorageKey(key) {
    this.storageKey = key;
  }

  read() {
    const data = this.backend.getItem(this.storageKey);
    return data;
  }

  parse() {
    const data = this.read();
    if (!data) return null;
    try {
      const parsed = JSON.parse(data);
      return parsed;
    } catch (error) {
      logger.error('Error parsing JSON:', error);
      return null;
    }
  }

  bindTo(something) {
    const data = this.parse();
    if (!data) return;
    const bound = Object.assign(something, data);
    return bound;
  }

  write(value) {
    if ('string' !== typeof value) {
      if (!!value && 'object' === typeof value) {
        value = JSON.stringify(value);
      }
    }
    this.backend.setItem(this.storageKey, value);
  }

  remove() {
    this.backend.removeItem(this.storageKey);
  }

  /**
   * Whether to store the data in localStorage.
   * @type {boolean}
   */
  _isLocal = false;

  set isLocal(value) {
    this._isLocal = value;
  }

  set isSession(maybe) {
    this._isLocal = !maybe;
  }

  get isLocal() {
    return this._isLocal;
  }

  get isSession() {
    return !this._isLocal;
  }

  /**
   * The storage object to use (localStorage or sessionStorage).
   * Defaults to localStorage.
   * @returns {Storage}
   */
  get backend() {
    if (this.isLocal) return localStorage;
    if (this.isSession) return sessionStorage;
    return localStorage;
  }
}

export class Storage extends Storable {
  /**
   *
   * @param key
   * @returns {Storage}
   */
  static forKey(key) {
    const storage = new Storage();
    storage.setStorageKey(key);
    return storage;
  }

  /**
   *
   * @param key
   * @returns {Storage}
   */
  static localForKey(key) {
    const storage = Storage.forKey(key);
    storage.isLocal = true;
    storage.isSession = false;
    return storage;
  }

  /**
   *
   * @param key
   * @returns {Storage}
   */
  static sessionForKey(key) {
    const storage = Storage.forKey(key);
    storage.isLocal = false;
    storage.isSession = true;
    return storage;
  }

  static local() {
    const storage = new Storage();
    storage.isLocal = true;
    storage.isSession = false;
    return storage;
  }

  static session() {
    const storage = new Storage();
    storage.isLocal = false;
    storage.isSession = true;
    return storage;
  }

  get value() {
    return this.read();
  }

  get object() {
    const objectified = this.parse() || {};
    return objectified;
  }
}
